import { PatientTrackables, TrackableMeasure, TrackableMeasureTypes } from '../../../../models/core';
import { MeasureEditorViewState } from './MeasureEditorViewState';


export function patientTrackablesToState(patientTrackables?:PatientTrackables, state?:MeasureEditorViewState) : MeasureEditorViewState {
    const conditionsList:Record<string, TrackableMeasure[]> = {};
    if(patientTrackables && patientTrackables.trackable) {
        const trackableList = patientTrackables.trackable;
        trackableList?.forEach((item) => {
            if(!conditionsList[item.type]) {
                conditionsList[item.type] = [];
            }
            conditionsList[item.type].push(item);
        });

        if(state) {
            const mi = state?.measures.filter((i) => !conditionsList[TrackableMeasureTypes.MEASURE]?.find((f) => f.id == i.id));
            const ci = state?.chronic.filter((i) => !conditionsList[TrackableMeasureTypes.CHRONIC]?.find((f) => f.id == i.id));
            const si = state?.suspect.filter((i) => !conditionsList[TrackableMeasureTypes.SUSPECT]?.find((f) => f.id == i.id));
            const di = state?.diagnosis.filter((i) => !conditionsList[TrackableMeasureTypes.DIAGNOSIS]?.find((f) => f.id == i.id));
            
            conditionsList[TrackableMeasureTypes.MEASURE] = [...conditionsList[TrackableMeasureTypes.MEASURE], ...mi];
            conditionsList[TrackableMeasureTypes.CHRONIC] = [...conditionsList[TrackableMeasureTypes.CHRONIC], ...ci];
            conditionsList[TrackableMeasureTypes.SUSPECT] = [...conditionsList[TrackableMeasureTypes.SUSPECT], ...si];
            conditionsList[TrackableMeasureTypes.DIAGNOSIS] = [...conditionsList[TrackableMeasureTypes.DIAGNOSIS], ...di];
        }
    }
    return {
        measuresUpdated:state?.measuresUpdated || false,
        measures:conditionsList[TrackableMeasureTypes.MEASURE] || state?.measures || [],
        chronicUpdated:state?.chronicUpdated || false,
        chronic:conditionsList[TrackableMeasureTypes.CHRONIC] || state?.chronic || [],
        suspectUpdated:state?.suspectUpdated || false,
        suspect:conditionsList[TrackableMeasureTypes.SUSPECT] || state?.suspect || [],
        diagnosisUpdated:state?.diagnosisUpdated || false,
        diagnosis:conditionsList[TrackableMeasureTypes.DIAGNOSIS] || state?.diagnosis || []
    }
}

export const copyTableConditionContent = (contentName:string, content: TrackableMeasure[]) => {
    let copyData:string = contentName;
    content?.forEach((it) => { copyData = copyData + `\n${it.name}: ${it.value}`; });
    navigator.clipboard.writeText(copyData);
}